module.exports = __webpack_public_path__ + "icon_map_mark.3023d9200f9d545fcf73b2e6aedca1d3.svg";